import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { Star } from "lucide-react";

export const SellerSpotlight = () => {
  const [s, setS] = useState(null);

  useEffect(() => {
    api.get("/spotlight/current").then(({ data }) => setS(data.spotlight)).catch(() => {});
  }, []);

  if (!s) return null;

  return (
    <section className="border-t border-white/5" data-testid="seller-spotlight">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 py-16">
        <div className="flex items-center gap-2 mb-6">
          <Star className="h-4 w-4 text-amber-400" />
          <span className="text-xs uppercase tracking-widest text-amber-400">Founding seller spotlight · this week</span>
        </div>
        <div className="rounded-2xl border border-amber-400/20 bg-gradient-to-br from-amber-400/5 to-transparent p-8 md:p-10">
          <div className="flex flex-wrap items-baseline gap-3">
            <h2 className="font-black tracking-tight text-3xl" data-testid="spotlight-name">{s.seller_name}</h2>
            {s.shop && <span className="text-sm text-neutral-400">· {s.shop}</span>}
            <span className="text-[10px] uppercase tracking-widest font-bold px-2 py-0.5 rounded-full bg-amber-400/10 border border-amber-400/30 text-amber-400">Founding seller</span>
          </div>
          <p className="mt-4 text-neutral-300 leading-relaxed max-w-3xl" data-testid="spotlight-story">{s.story}</p>
          {s.quote && <p className="mt-4 text-sm text-neutral-400 italic">"{s.quote}"</p>}
          <div className="mt-6 flex flex-wrap gap-3">
            <Link to={`/discover?seller=${s.seller_id}`} data-testid="spotlight-shop-link"
              className="px-5 h-10 leading-10 rounded-full bg-white text-black font-bold text-xs hover:bg-neutral-200 transition-colors">
              Shop {s.shop || s.seller_name}
            </Link>
            <Link to="/founders" className="px-5 h-10 leading-10 rounded-full border border-white/15 text-white font-bold text-xs hover:border-white/40 transition-colors">
              Meet all founders
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
};
